import { render, staticRenderFns } from "./CDatepicker.vue?vue&type=template&id=bbe0e39a"
import script from "./CDatepicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./CDatepicker.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports